import { Component, OnDestroy, OnInit } from '@angular/core';
import { ResultpagesharedService } from '../../../../share/service/resultpageshared.service';
import { ActivatedRoute } from '@angular/router';
import { OffersOfApplication } from '../../../../share/type/result_type';
import { Subscription } from 'rxjs';
import { closingtrackUrl } from '../../../../utils/url';
import { OfferDataUtilsService } from '../../../../share/service/offer-data-utils.service';
import { ResultpageService } from '../../../../share/service/resultpage.service';

@Component({
  selector: 'app-offer-details',
  templateUrl: './offer-details.component.html',
  styleUrl: './offer-details.component.scss',
})
export class OfferDetailsComponent implements OnInit, OnDestroy {
  private offerId!: string;
  public card: OffersOfApplication;
  private dataOffersSubscription?: Subscription;
  private eternalOffersSubscription?: Subscription;

  constructor(
    public sharedResultService: ResultpagesharedService,
    private route: ActivatedRoute,
    private offerDataUtils: OfferDataUtilsService,
    private resultpageService: ResultpageService,
  ) {}

  ngOnInit() {
    window.scrollTo(0, 0);
    this.offerId = this.route.snapshot.paramMap.get('offerId');
    const fromActiveTab = history.state?.pageType === 'active';

    const cachedCard = this.resolveOfferFromCache();
    if (cachedCard) {
      this.card = cachedCard;
    }

    this.sharedResultService.initComponent(
      fromActiveTab ? { eternalTab: 'active' } : undefined,
    );

    if (this.sharedResultService.eternalPage) {
      this.eternalOffersSubscription =
        this.sharedResultService.eternalOffersDataObserv$.subscribe((data) => {
          const found = this.offerDataUtils.findOfferById(data, this.offerId);
          if (found) {
            this.card = found;
          }
        });
    } else {
      this.dataOffersSubscription =
        this.sharedResultService.getObserv$.subscribe({
          next: () => {
            this.card = this.sharedResultService.getSingleOffer(this.offerId);
          },
        });
    }
  }

  ngOnDestroy() {
    this.sharedResultService.ngOnDestroy();
    this.dataOffersSubscription?.unsubscribe();
    this.eternalOffersSubscription?.unsubscribe();
  }

  private resolveOfferFromCache(): OffersOfApplication | undefined {
    return (
      this.offerDataUtils.findOfferById(
        this.offerDataUtils.getEternalOffersDataSnapshot(),
        this.offerId,
      ) ??
      this.offerDataUtils.getSingleOfferById(
        this.resultpageService.getOffersDataSnapshot(),
        this.offerId,
      )
    );
  }

  onClosingTrack(token: string, loanAmount: number): void {
    window.location.href = closingtrackUrl(
      token,
      loanAmount,
      this.card.contractStateFlow,
    );
  }
}
